import { getWindowLocation } from 'utils/window';

export const requestResetPassword = async ({
  email,
  namespaceNickname,
  heliumEndpoint,
  resetUrlParams,
}: {
  email: string;
  namespaceNickname: string;
  heliumEndpoint: string;
  resetUrlParams: URLSearchParams;
}) => {
  const baseUrl = getWindowLocation().href.split('?')[0];
  const payload = {
    email,
    namespaceNickname,
    resetUrl: `${baseUrl}?${resetUrlParams}`,
  };

  const resetPasswordResponse = await fetch(
    `${heliumEndpoint}/auth/resetPassword`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  );

  return resetPasswordResponse;
};
